__webpack_require__.p = "/assets/turbo/16c0e3fb/quellede/_next/";